import fulfill from '../../../fulfill';
import { SideEffectFunction } from '../../../sideEffects';
import { CORE_API_HOSTNAME } from '../../../env';
import {
    ActionTypes,
    FetchInitiateVippsConnectionResponse,
    InitiateVippsConnection,
    VippsApiError,
    UpdateAccountAndInitiateVippsConnection,
    UpdateVippsConnection,
    UpdateVippsConnectionResponse
} from './actions';
import { VippsConnection, UpdateAccount } from '../../../types/management-auth';

const fetchInitiateVippsConnection: SideEffectFunction<
    InitiateVippsConnection | UpdateAccountAndInitiateVippsConnection,
    FetchInitiateVippsConnectionResponse
> = async action => {
    const result: FetchInitiateVippsConnectionResponse = await fulfill.post({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/management/settings/connections/vipps`,
        handlers: {
            200: (response: VippsConnection) => ({
                type: ActionTypes.FetchInitiateVippsConnectionResponse,
                payload: {
                    response,
                },
                meta: {
                    cause: action,
                },
            }),
            500: returnVippsApiError,
            501: returnVippsApiError,
            502: returnVippsApiError,
            503: returnVippsApiError,
            504: returnVippsApiError,
        },
    });
    return result;
};
const fetchUpdateVippsConnection: SideEffectFunction<
    UpdateVippsConnection,
    UpdateVippsConnectionResponse
> = async action => {
    const result: UpdateVippsConnectionResponse = await fulfill.put({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/management/settings/connections/vipps`,
        handlers: {
            200: (response: VippsConnection) => ({
                type: ActionTypes.UpdateVippsConnectionResponse,
                payload: {
                    response,
                },
                meta: {
                    cause: action,
                },
            }),
            500: returnVippsApiError,
            501: returnVippsApiError,
            502: returnVippsApiError,
            503: returnVippsApiError,
            504: returnVippsApiError,
        },
    });
    return result;
};

const returnVippsApiError = (): VippsApiError => ({
    type: ActionTypes.VippsApiError,
    payload: {},
});

const updateAccountThenfetchInitiateVippsConnection: SideEffectFunction<
    UpdateAccountAndInitiateVippsConnection,
    FetchInitiateVippsConnectionResponse
> = async (action, getState) => {
    // Update account first
    await fulfill.put<UpdateAccount>({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/management/settings`,
        json: action.payload.account,
        handlers: {
            200: () => {},
        },
    });
    return fetchInitiateVippsConnection(action, getState);
};

const effects = {
    [ActionTypes.UpdateAccountAndInitiateVippsConnection]: updateAccountThenfetchInitiateVippsConnection,
    [ActionTypes.InitiateVippsConnection]: fetchInitiateVippsConnection,
    [ActionTypes.UpdateVippsConnection]: fetchUpdateVippsConnection,
};

export default effects;
